import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HistoryEduIcon(props: IconProps) {
    return <Icon {...props} iconKey={"history_edu"}/>
}
